import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { FxSwapRegular } from '@/store/swap/state.ts';

export const SavedSwapRegularValidator = arkScope.type({
  type: "'FxSwap'",
  properties: {
    'type?': "'standard' | 'uneven' | 'historical'",
    'currencyPair?': 'string',
    'nearNotional?': 'number',
    'farNotional?': 'number',
    currencyIndex: arkScope.type('CurrencyChoice').default(1),
    'nearExpiryDateTenor?': 'string',
    'farExpiryDateTenor?': 'string',
    'nearPrice?': 'BidAsk',
    'farPrice?': 'BidAsk',
  },
  tileId: 'string',
  clientId: 'number?',
  isNonDeliverable: 'false',
});

export type SavedSwapRegular = typeof SavedSwapRegularValidator.infer;
export const SavedSwapRegular = {
  fromFxSwapRegular: (x: FxSwapRegular, tileId: string): SavedSwapRegular => ({
    type: 'FxSwap',
    isNonDeliverable: false,
    properties: {
      type: x.properties.type,
      currencyPair: x.properties.currencyPair,
      nearNotional: x.properties.nearNotional,
      farNotional: x.properties.farNotional,
      currencyIndex: x.properties.nearNotionalCurrencyIndex ?? 1,
      nearExpiryDateTenor: x.properties.nearExpiryDateTenor,
      farExpiryDateTenor: x.properties.farExpiryDateTenor,
      nearPrice: x.properties.nearPrice,
      farPrice: x.properties.farPrice,
    },
    tileId,
    clientId: x.clientId,
  }),
} as const;
